import { render, staticRenderFns } from "./price.vue?vue&type=template&id=7bc6f378&scoped=true&"
import script from "./price.vue?vue&type=script&lang=js&"
export * from "./price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc6f378",
  null
  
)

export default component.exports